import { render } from "./HomeNavigation.vue?vue&type=template&id=15b70eab&scoped=true"
import script from "./HomeNavigation.vue?vue&type=script&lang=js"
export * from "./HomeNavigation.vue?vue&type=script&lang=js"

import "./HomeNavigation.vue?vue&type=style&index=0&id=15b70eab&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15b70eab"]])

export default __exports__